/* eslint-disable */
export function combineClasses(
  ...classNames: (string | boolean | undefined)[]
): string {
  return classNames.filter((c) => !!c).join(' ');
}
